import React from 'react'
import {Flex, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

const RecipesNoResults = () => {
    return (
        <Flex
            flexDir="column"
            alignItems="center"
            flex="1 0 0"
            marginTop={{base: 'small.lg', lg: 'large.lg'}}
            marginBottom={{base: 'xlarge.base', lg: 'xlarge.lg'}}
        >
            <Text textStyle="head-xsmall" fontWeight="normal" textAlign="center">
                We are sorry, but your search didn&apos;t return any matching recipes for the
                options you entered. Please review your options and try rephrasing your request.
            </Text>
        </Flex>
    )
}

export default RecipesNoResults
